import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAdminJobList, fetchPublicJobList } from "./AdminJobListAPI";

const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

export const fetchAdminJobListAsync = createAsyncThunk(
  "JobList/fetch",
  async (page, { rejectWithValue }) => {
    try {
      const data = await fetchAdminJobList(page);  // Assuming this is your API call

      const resp = data?.response;  // Get the entire response object
      // console.log("resp", resp)
      if (!resp || !resp.data) {
        throw new Error("Invalid response structure");
      }

      // Return both the jobs data and the next page URL
      return {
        jobs: resp.data,  // The array of job data
        totalJobs: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);  // Reject with the error message if something goes wrong
    }
  }
);


const AdminJobListSlice = createSlice({
  name: "AdminJobList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminJobListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminJobListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchAdminJobListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectAdminJobList = (state) => state.adminJobList.data.jobs;
export const selectAdminJobListTotal = (state) => state.adminJobList.data.totalJobs;

export default AdminJobListSlice.reducer;
